import '../CsplCard/CsplCard.css';
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import FileResource from "../../Resources/CommonResources/FileResource";
function CsplCard(props){
    const[base64String,setBase64String] = useState("");
    const { t } = useTranslation("common");
    const[getUploadedContent]=FileResource();

    useEffect(() => {
        if(!_.isEmpty(props.localServerPath)){
            getUploadedContent(props.localServerPath).then(
              (res) => {
                if (res !== null && res !== "") {
                    setBase64String("data:image/png;base64,"+res)
                }
              },
              (error) => {}
            );
          }          
      },[props.localServerPath]);

    return(     
        <div className='cspl-card-border'>
            <div className='cspl-card-top-content'>
                { props.localServerPath != null && props.localServerPath != undefined && props.localServerPath !== '' ? (
                    <p><img src={base64String} className='cspl-card-image' alt={t("form.image")} /></p>
                ) : (
                    <p><img src={props.imgUrl} className='cspl-card-image' alt={t("form.image")} /></p>
                )}
            </div>
            <div  className='cspl-card-bottom-content'>
                <p>{props.imgType}</p>
            </div>
        </div>
    )
}
export default CsplCard;

